import { CUSTOM_EVENT_ID, FILTER_DATES, FILTER_DESTINATION, FILTER_ROOMS } from './constants'
import {anchorModuleMap} from './configuration';

const pushEvent = function (data) {
  const event = new CustomEvent(CUSTOM_EVENT_ID, {
    detail: data,
    cancelable: true,
  })
  return window.top.dispatchEvent(event)
}

export const pushOpenDestinationFilter = function (opts) {
  return pushEvent({
    id: FILTER_DESTINATION,
    type: 'open',
    opts,
  });
};

export const pushOpenDatesFilter = function (opts) {
  return pushEvent({
    id: FILTER_DATES,
    type: 'open',
    opts,
  })
}

export const pushOpenRoomsFilter = function (opts) {
  return pushEvent({
    id: FILTER_ROOMS,
    type: 'open',
    opts,
  })
}

export const pushSubmitSearchBox = function (opts) {
  return pushEvent({
    type: 'submit',
    opts,
  })
}

export const openFilterIfExists = function (anchor, onSuccess = () => {}, onError = () => {}) {
  const filter = anchorModuleMap[anchor];

  if (filter) {
    pushEvent({
      id: filter,
      type: 'open',
    });
    onSuccess();
  } else {
    onError();
  }
};

export default pushEvent;
